import { useDispatch, useSelector } from 'react-redux';
import { setIrrandiance } from 'store/slices/IrradianceSlice';
import { RootState } from 'store';
import { IrradianceState } from 'store/slices/IrradianceSlice/type';
import { MonthButtonsWrap } from './style';
import { debounce } from '../../../util';
import Button from 'components/Basic/Button';
import { MONTHS } from '../../../constants';

export default function MonthButtons() {
	const { selectedMonth, irradianceImages, showIrradiance } = useSelector((state: RootState) => state.Irradiance.data as IrradianceState);
	const { fullScreenEnabled } = useSelector((state: RootState) => state.toolNewPostions.data);
	const imagerySource = useSelector((state: RootState) => state.roofData.data.imagerySource);
	const dispatch = useDispatch();
	const deboubceToggle = debounce((selectedMonth: number) => dispatch(setIrrandiance({ selectedMonth })), 10);

	if (!showIrradiance || !irradianceImages[imagerySource as keyof typeof irradianceImages]?.length) {
		return null;
	}

	return (
		<MonthButtonsWrap fullScreenEnabled={fullScreenEnabled} 
			className={`${fullScreenEnabled ? 'monthwrap active' : 'monthwrap'}`}
		>
			{
				MONTHS.map((month, index: number) => (
					<Button 
						className="months-btn"
						style={{
							background: `${selectedMonth === index ? 'var(--primary)' : 'var(--defaultBgColor)'}`,
							border: `${selectedMonth === index ? '1px solid var(--primary)' : '1px solid var(--borderColor)'}`,
							color: `${selectedMonth === index ? 'var(--btnLabel)' : 'var(--subHeadingColor)'}`,
						}}
						onClick={() => deboubceToggle(index)}
						key={month}>
						{month}
					</Button>
				))
			}
		</MonthButtonsWrap>

	);
}